module.exports = __webpack_public_path__ + "img/spinner.e95a7c4a.gif";